module.exports = __webpack_public_path__ + "img/grid-list.2b13f42a.svg";